module.exports = __webpack_public_path__ + "img/004.a95ff110.png";